<template>
  <transition name="fade" mode="out-in">
    <div class="cp-dlt">
      <div class="topBar">
        <span class="btn-back iconfont" @click.stop="back()">&#xe61c;</span>
        <span class="title">大乐透</span>
      </div>
      <div class="content">
        <img src="../../images/404.png" class="img-404">
        <p class="text" @click.stop="goSS()">不好意思,未能抽出时间用Vue重写,请转至'双色球'！</p>
      </div>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
  export default{
    methods: {
      back() {
        this.$router.back();
      },
      goSS() {
        this.$router.push('/ssc');
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  .cp-dlt
    position:fixed
    z-index:50
    top:0
    bottom:0
    left:0
    right:0
    background-color:#f8f8f0
    &.fade-enter-active, &.fade-leave-active
      transition:all 0.4s linear
    &.fade-enter, &.fade-leave-active
      transform:translate(100%, 0)
    .topBar
      width:100%
      height:40px
      color:#fff
      background-color:#d91d36
      .btn-back
        padding:0 10px
        font-weight:600
        font-size:16px
        line-height:40px
      .title
        font-size:17px
        font-weight:600
        line-height:40px
        letter-spacing:2px
    .content
      display:table
      width:100%
      height:100%
      text-align:center
      .img-404
        margin:30% auto 0px
        width:100px
        height:100px
      .text
        margin:20px auto
        width:80%
        font-size:14px
        line-height:24px
        color:#999
        letter-spacing:2px
</style>



// WEBPACK FOOTER //
// dlt.vue?281509f2